angular.module('ikeweb.spike.measure').factory('measurementFactory', [

    function() {

        function Measurement(dimensions, _area, perimeter, name, id, type) {

            var area = _area;

            function getDimensions() {
                return dimensions || [];
            }

            function hasArea() {
                return !!area;
            }

            function isQuad() {
                return hasArea() && getDimensions().length === 4;
            }

            function getArea() {
                return hasArea() ? area : 0;
            }

            function setArea(value) {
                area = value;
            }

            function getPerimeter() {
                return perimeter ? perimeter : 0;
            }

            function getName() {
                return name || '';
            }

            function getId() {
                return id;
            }

            function getType() {
                return type;
            }

            function getWidth() {
                return isQuad() ? Math.max(getDimensions()[0], getDimensions()[2]) : 0;
            }

            return {
                getDimensions: getDimensions,
                getArea: getArea,
                getPerimeter: getPerimeter,
                getName: getName,
                getId: getId,
                hasArea: hasArea,
                isQuad: isQuad,
                getType: getType,
                setArea: setArea,
                getWidth: getWidth
            };
        }

        function create(measurementData) {
            return new Measurement(measurementData.dimensions, measurementData.area, measurementData.totalDimension,
                measurementData.name, measurementData.id, measurementData.type);
        }

        function createMeasurement(measurementData) {

            if (!measurementData) {
                throw new Error('Measurement data is required');
            }

            return new Measurement(measurementData.dimensions, measurementData.area, measurementData.totalDimension,
                measurementData.type, measurementData.id, measurementData.type);
        }

        return {
            createMeasurement: createMeasurement,
            create: create
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurement/measurement.factory.js
// module id = 518
// module chunks = 0